export function isInternalUser(session) {
  return session?.user_type === 'internal';
}

export function isCustomerUser(session) {
  return session?.user_type === 'customer';
}

export function getDefaultCustomerId(session) {
  return session?.default_customer_id || session?.customers?.[0]?.id || null;
}

export function getSessionRoles(session) {
  return session?.roles || [];
}

export function hasRole(session, roleName) {
  return getSessionRoles(session).includes(roleName);
}

export function isSuperadminOrDeveloper(session) {
  return hasRole(session, 'system_superadmin') || hasRole(session, 'developer');
}

export function getSessionPermissions(session, customerId = null) {
  if (!session) {
    return [];
  }

  if (isInternalUser(session)) {
    return session.permissions || [];
  }

  if (customerId) {
    const customer = session.customers?.find((c) => c.id === customerId);

    return customer?.permissions || [];
  }

  const preferredId = getDefaultCustomerId(session);
  const preferredCustomer = session.customers?.find((c) => c.id === preferredId);
  const activeCustomer = preferredCustomer
    || session.customers?.find((c) => c.membership_status === 'active')
    || session.customers?.[0];

  return activeCustomer?.permissions || [];
}

export function hasPermission(session, permission, customerId = null) {
  if (!permission) {
    return true;
  }

  return getSessionPermissions(session, customerId).includes(permission);
}

export function hasAnyPermission(session, permissions = [], customerId = null) {
  if (!permissions.length) {
    return true;
  }

  const userPermissions = getSessionPermissions(session, customerId);

  return permissions.some((permission) => userPermissions.includes(permission));
}

export function canAccessCustomerPortal(session) {
  if (!session) {
    return false;
  }

  if (isCustomerUser(session)) {
    return session.customers?.some((c) => c.membership_status === 'active') ?? false;
  }

  if (isInternalUser(session)) {
    return hasPermission(session, 'system.support.view');
  }

  return false;
}
